import columnConfig from './components/column-config'
import barAndLineConfig from './components/bar-and-line-config'
import pieConfig from './components/pie-config'
import funnelConfig from './components/funnel-config'
import radarConfig from './components/radar-config'
import blockConfig from './components/block-config'
import gridConfig from './components/grid-config'
import percentConfig from './components/percent-config'
import scatterConfig from './components/scatter-config'
import compareConfig from './components/compare-config'
import mapConfig from './components/map-config'

const componentList = [
  columnConfig, pieConfig, funnelConfig, radarConfig, blockConfig, gridConfig, percentConfig, scatterConfig,
  compareConfig, mapConfig, barAndLineConfig
]

const components = {}

for (let i = 0; i < componentList.length; i++) {
  components[componentList[i].typeCode] = componentList[i]
}

export default components



// WEBPACK FOOTER //
// ./src/custom/components/page/analyse/show/showConfigComponents.js